import { GUIDE_ARTICLES } from './registry';

/** High-priority guides for landing internal linking and Bing discovery. */
export const FEATURED_GUIDE_IDS = ['s1', 'q1', 'g1', 'r1', 'c1'];

export const getFeaturedGuides = () =>
  FEATURED_GUIDE_IDS.map((id) => GUIDE_ARTICLES.find((article) => article.id === id)).filter(Boolean);
